<template>
  <auth-layout ilustracao="empresa" :slides="slides">
    <form class="form" novalidate @submit.prevent="Entrar">
      <h1 class="form__title">Com qual credor você vai trabalhar?</h1>
      <p class="form__sub">Sua conta tem acesso a {{ textoQuantidade }}.</p>

      <div v-if="mostrarBusca" class="field search">
        <label class="field__label" for="empresa-busca">Buscar</label>
        <input
          id="empresa-busca"
          v-model="busca"
          class="field__input"
          autocomplete="off"
          placeholder="Nome, código ou CNPJ"
        />
      </div>

      <ul class="companies" role="radiogroup" aria-label="Empresas">
        <li v-for="empresa in empresasFiltradas" :key="empresa.id">
          <label class="company" :class="{ 'is-selected': isSelectEmpresa === empresa.id }">
            <input v-model="isSelectEmpresa" type="radio" name="empresa" :value="empresa.id" />
            <span class="company__radio"></span>
            <span class="company__body">
              <span class="company__name">{{ empresa.name }}</span>
              <span class="company__meta">Cód. {{ empresa.id }} · {{ empresa.cpf_cnpj }}</span>
            </span>
          </label>
        </li>
        <li v-if="!empresasFiltradas.length" class="companies__empty">Nenhuma empresa encontrada.</li>
      </ul>

      <button class="btn" type="submit" :disabled="!isSelectEmpresa || loading">
        <v-progress-circular v-if="loading" indeterminate size="20" width="2" color="#FFD400" />
        <span v-else>Entrar</span>
      </button>

      <div class="split-links">
        <a class="link" href="#" @click.prevent="cadastrarEmpresa">Cadastrar novo credor</a>
        <a class="link link--muted" href="#" @click.prevent="sair">Sair</a>
      </div>
    </form>
  </auth-layout>
</template>

<script>
import { mapActions } from "vuex";
import AuthLayout from "@/components/auth/AuthLayout.vue";

/** A busca só aparece a partir deste número de empresas (exclusive). */
const LIMITE_SEM_BUSCA = 5;

/** Minúsculas, sem acento e sem pontuação — "12.345.678/0001-90" casa com "12345678". */
function normalizar(texto) {
  return String(texto == null ? "" : texto)
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, "");
}

export default {
  name: "EmpresasComponent",
  components: { AuthLayout },
  data: () => ({
    slides: [
      {
        titulo: "Escolha o credor",
        subtitulo: "Inclusões, baixas e protocolos ficam separados por empresa.",
      },
    ],
    isSelectEmpresa: null,
    loading: false,
    busca: "",
    items: [],
  }),
  computed: {
    textoQuantidade() {
      const n = this.items.length;
      return n === 1 ? "1 empresa" : `${n} empresas`;
    },
    mostrarBusca() {
      return this.items.length > LIMITE_SEM_BUSCA;
    },
    empresasFiltradas() {
      const termo = normalizar(this.busca).trim();
      if (!termo) return this.items;
      return this.items.filter((empresa) =>
        [empresa.name, empresa.id, empresa.cpf_cnpj].some((campo) => normalizar(campo).includes(termo))
      );
    },
  },
  mounted() {
    this.items = this.$store.state.auth.user.empresas || [];
  },
  methods: {
    ...mapActions("auth", [
      "ActionSignOut",
      "ActionDomainLogin",
      "ActionSelectDomain",
    ]),
    async sair() {
      try {
        await this.ActionSignOut();
        this.$router.push({ name: "login" });
      } catch (error) {
        alert(
          error.data ? error.data.message : "Não foi possivel sair do sistema"
        );
      }
    },

    cadastrarEmpresa() {
      this.$router.push({ name: "Cadastro de Credor" });
    },
    async Entrar() {
      if (!this.isSelectEmpresa || this.loading) return;
      try {
        this.loading = true;
        await this.ActionSelectDomain(this.isSelectEmpresa);
        this.loading = false;
        this.$router.push({ name: "Home" });
      } catch (error) {
        this.loading = false;
        alert(
          error.data ? error.data.message : "Não foi possivel sair do sistema"
        );
      }
    },
  },
};
</script>

<style scoped src="@/components/auth/auth-form.css"></style>

<style scoped>
.search {
  margin-bottom: 12px;
}

.companies {
  list-style: none;
  margin: 0 0 20px;
  padding: 0;
  max-height: 264px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}
.company {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: background 0.12s;
}
.companies > li:last-child .company {
  border-bottom: 0;
}
.company:hover {
  background: #f8fafc;
}
/* Radio nativo invisível: mantém setas/Tab/Espaço do teclado */
.company input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.company__radio {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1.5px solid #94a3b8;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.company input:focus-visible + .company__radio {
  outline: 3px solid rgba(0, 82, 160, 0.3);
  outline-offset: 2px;
}

.company.is-selected {
  background: #FFFBEA;
}
.company.is-selected .company__radio {
  border-color: #0052A0;
}
.company.is-selected .company__radio::after {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #0052A0;
}

.company__body {
  min-width: 0;
}
.company__name {
  display: block;
  font-size: 0.88rem;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.company__meta {
  display: block;
  font-size: 0.76rem;
  color: #64748b;
  margin-top: 2px;
  font-variant-numeric: tabular-nums;
}

.companies__empty {
  padding: 20px 14px;
  font-size: 0.84rem;
  color: #64748b;
  text-align: center;
}

.split-links {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  font-size: 0.85rem;
}
</style>
